const zh = {
  language_zh: '中文',
  language_en: '英文',

  login_systemHeader: '上海兴驰媒体广告牌智控系统',
  login_header: '系统登录',
  login_userAccount: '用户名',
  login_userAccountMsg: '请输入用户名',
  login_password: '密码',
  login_passwordMsg: '请输入密码',
  login_code: '验证码',
  login_codeMsg: '请输入验证码',
  login_changeImg: '点击更换验证码',
  login_rememberpwd: '记住账户密码',
  login_submit: '登录',
  login_reset: '重置',
  login_Footer1: '建议使用',
  login_Footer2: '谷歌，火狐或IE11以上浏览器',
  login_Footer3: '。如使用360，QQ，猎豹等浏览器请选择',
  login_Footer4: '极速模式。',
}
export default zh
